module.exports = __webpack_public_path__ + "img/4.957b48a1.gif";